import axios from 'axios';
import { toast } from 'react-toastify';
import { externalUrl } from '../data/externalUrls';

const BASE = `${externalUrl.flaskServiceUrl}/CS_Diagnostics`;

/** @param {{ cs_diagonostics: { device_id: string, start_date: string, end_date: string } }} apiJson */
export function buildDiagnosticsFormBody(apiJson) {
  const p = apiJson.cs_diagonostics;
  const formData = new URLSearchParams();
  formData.append('device_id', p.device_id);
  formData.append('start_time', p.start_date);
  formData.append('end_time', p.end_date);
  return formData;
}

/** @param {{ cs_diagonostics: { device_id: string, start_date: string, end_date: string } }} apiJson */
export function buildMqttFormBody(apiJson) {
  const p = apiJson.cs_diagonostics;
  const formData = new URLSearchParams();
  formData.append('device_id', p.device_id);
  formData.append('start_time', p.start_date);
  return formData;
}

export async function fetchChargingStations() {
  const res = await axios.get(`${BASE}/charging_stations`);
  return res.data?.data ?? [];
}

export function postMqttTrigger(apiJson) {
  return axios.post(`${BASE}/MQTT_Button`, buildMqttFormBody(apiJson));
}

export function postSummaryEndpoint(endpoint, apiJson) {
  return axios.post(`${BASE}/${endpoint}`, buildDiagnosticsFormBody(apiJson));
}

export async function fetchCsInformation(apiJson) {
  const response = await axios.post(`${BASE}/cs_information`, buildDiagnosticsFormBody(apiJson));
  const data = response?.data?.data;
  if (data && data.length > 0) {
    return data[0];
  }
  toast.warning('CS information data not found or empty.');
  return null;
}

export async function fetchCsLogCustomer(apiJson) {
  const response = await axios.post(`${BASE}/cs_log_customer`, buildDiagnosticsFormBody(apiJson));
  const data = response?.data?.data;
  if (!data || data.length === 0) {
    toast.warning('Customer wise data not found or empty.');
    return [];
  }
  return data;
}

export async function fetchUploadLog(apiJson) {
  const response = await axios.post(`${BASE}/upload_log`, buildDiagnosticsFormBody(apiJson));
  const data = response?.data?.data;
  if (!data || data.length === 0) {
    toast.warning('CS log file data not found or empty.');
    return [];
  }
  toast.success('Data Fetched Successfully');
  return data;
}

export async function fetchSoftwareVersions() {
  const res = await axios.get(`${externalUrl.flaskServiceUrl}/Version_Update/cs_software_versions_list`);
  return res.data?.data?.cs_software_versions ?? [];
}

export function postVersionUpdate(params) {
  const p = params.cs_version_update;
  const formData = new URLSearchParams();
  formData.append('type', p.type);
  formData.append('device_id', p.device_id);
  formData.append('version', p.version);
  formData.append('username', p.username);
  formData.append('usermail', p.usermail);
  formData.append('reason', p.reason);

  return axios.post(`${externalUrl.flaskServiceUrl}/Version_Update/cs_version_change`, formData);
}

/** @param {{ cs_diagonostics: { device_id: string } }} apiJson */
export function buildMetadataToggleFormBody(apiJson, metadataOn) {
  const p = apiJson.cs_diagonostics;
  const auth = JSON.parse(localStorage.getItem('auth'));
  const formData = new URLSearchParams();
  formData.append('device_id', p.device_id);
  formData.append('username', auth?.user?.name ?? '');
  formData.append('usermail', auth?.user?.email ?? '');
  formData.append('metadata_on', String(metadataOn));
  return formData;
}

export function postStartMetadata(apiJson) {
  return axios.post(
    `${externalUrl.flaskServiceUrl}/Version_Update/cs_start_metadata`,
    buildMetadataToggleFormBody(apiJson, true)
  );
}

export function postStopMetadata(apiJson) {
  return axios.post(
    `${externalUrl.flaskServiceUrl}/Version_Update/cs_start_metadata`,
    buildMetadataToggleFormBody(apiJson, false)
  );
}

export function fetchMetadata(apiJson) {
  return postSummaryEndpoint('metadata', apiJson);
}


